/**
 *@author       罗朝军
 *@date         2021/9/15 20:14
 *@Copyright    天源迪科信息技术股份有限公司
 *@Description
 */
import request from "@/config/utils/request";

// 用于专家评标项目列表查询。
export function scpQryExpertEvaProjectListApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/qryExpertEvaProjectList",
    method: method,
    data
  });
}

// 用于评标准备详情查询
export function scpQryBidEvaPrepareDetailApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/qryBidEvaPrepareDetail",
    method: method,
    data
  });
}

// 用于评标专家列表查询
export function scpQryJoinExpertListApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/qryJoinExpertList",
    method: method,
    data
  });
}

// 用于专家签到记录列表查询。
export function scpQryExpertSignListApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/qryExpertSignList",
    method: method,
    data
  });
}

// 专家签到
export function scpDealExpertSignApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/dealExpertSign",
    method: method,
    data
  });
}

// 用于专家签到。
export function scpQealExpertWechatSignApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/dealExpertWechatSign",
    method: method,
    data
  });
}

// 用于专家承诺书查询
export function scpQryExpertCommitmentApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/qryExpertCommitment",
    method: method,
    data
  });
}

// 用于专家承诺书同意
export function scpDealExpertCommitmentApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/dealExpertCommitment",
    method: method,
    data
  });
}

// 专家评分表制定
export function scpDealExpertScoreFormulateApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/dealExpertScoreFormulate",
    method: method,
    data
  });
}

// 供应商符合性检查列表查询
export function scpQrySupComCheckListApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/qrySupComCheckList",
    method: method,
    data
  });
}

// 基准价筛选列表
export function qryEvaScreenPackList(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/qryEvaScreenPackList",
    method: method,
    data
  });
}

// 基准价筛选 生效
export function dealEvaScreenPack(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/dealEvaScreenPack",
    method: method,
    data
  });
}

// 分包商符合性检查保存
export function scpDealSupComCheckSaveApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/dealSupComCheckSave",
    method: method,
    data
  });
}

// 用于分包商符合性检查专家确认列表查询
export function scpQrySupComCheckConfirmListApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/qrySupComCheckConfirmList",
    method: method,
    data
  });
}

// 用于分包商符合性检查确认详情查询
export function scpQrySupComCheckConfirmDetailApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/qrySupComCheckConfirmDetail",
    method: method,
    data
  });
}

// 用于分包商符合性检查确认
export function scpDealSupComCheckConfirmApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/dealSupComCheckConfirm",
    method: method,
    data
  });
}

// 用于分包商符合性检查生效
export function scpDealSupComCheckEffectApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/dealSupComCheckEffect",
    method: method,
    data
  });
}

// 用于分包商符合性检查校验黑名单
export function checkSubconControlAndBlack(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/checkSubconControlAndBlack",
    method: method,
    data
  });
}

// 用于专家评分包件分类查询
export function scpQryExpertScorePackListApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/qryExpertScorePackList",
    method: method,
    data
  });
}

// 用于专家分包商报价待评分列表查询
export function scpQryExpertSupPackQuoteToScoreApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/qryExpertSupPackQuoteToScore",
    method: method,
    data
  });
}

// 用于专家分包商报价评分列表查询
export function scpQryExpertSupPackQuoteScoreApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/qryExpertSupPackQuoteScore",
    method: method,
    data
  });
}

// 用于专家分包商评分
export function scpDealExpertSupScoreApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/dealExpertSupScore",
    method: method,
    data
  });
}

// 用于专家分包商评分提交
export function scpDealExpertSupScoreSubmitApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/dealExpertSupScoreSubmit",
    method: method,
    data
  });
}

// 用于查询采购方案详情包件
export function scpQueryPurchaseSchemePackageApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/queryPurchaseSchemePackage",
    method: method,
    data
  });
}

// 用于查询采购方案包件详情并看是否分包
export function scpListPurchaseSchemePackageApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/listPurchaseSchemePackage",
    method: method,
    data
  });
}

// 用于评分汇总查询  传purStep: "080607",查打分汇总
export function scpQrySumScoreApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/qrySumScore",
    method: method,
    data
  });
}

// 用于评分汇总包件列表查询
export function scpQrySumScorePackListApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/qrySumScorePackList",
    method: method,
    data
  });
}

// 用于评分汇总专家打分列表查询
export function scpQrySumScoreExpertScoreListApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/qrySumScoreExpertScoreList",
    method: method,
    data
  });
}

// 用于专家分包商评分撤销
export function scpDealExpertSupScoreCancelApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/dealExpertSupScoreCancel",
    method: method,
    data
  });
}

// 用于评分汇总计算查询
export function scpQrySumScoreCalculateApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/qrySumScoreCalculate",
    method: method,
    data
  });
}

// 用于评分汇总保存   传purStep: "080607",查打分汇总
export function scpDealSumScoreSaveApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/dealSumScoreSave",
    method: method,
    data
  });
}

// 用于评分汇总提交
export function scpDealSumScoreSubmitApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/dealSumScoreSubmit",
    method: method,
    data
  });
}

// 用于查询是新单子还是老单子
export function selectSchemeVersionById(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/selectSchemeVersionById",
    method: method,
    data
  });
}

// 用于未提交评分专家列表查询
export function scpQryNotSubmitScoreExpertListApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/qryNotSubmitScoreExpertList",
    method: method,
    data
  });
}

// 用于评标报告详情查询。
export function scpQryBidReportDetailApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/qryBidReportDetail",
    method: method,
    data
  });
}

// 用于分包商投标文件批量下载信息查询
export function scpQrySupBiddingFileInfoListApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/qrySupBiddingFileInfoList",
    method: method,
    data
  });
}

// 用于附件查询
export function scpQryFileinfoListApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/qryFileinfoList",
    method: method,
    data
  });
}

// 用于评标报告保存
export function scpDealBidReportSaveApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/dealBidReportSave",
    method: method,
    data
  });
}

// 用于评标报告提交确认
export function scpDealBidReportSubmitApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/dealBidReportSubmit",
    method: method,
    data
  });
}

// 用于评标报告专家确认列表查询
export function scpQryBidReportExpertConfirmListApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/qryBidReportExpertConfirmList",
    method: method,
    data
  });
}

// 用于评标报告推荐列表查询
export function scpQryBidReportRecommendListApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/qryBidReportRecommendList",
    method: method,
    data
  });
}

// 用于评标报告生效
export function scpDealBidReportEffectApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/dealBidReportEffect",
    method: method,
    data
  });
}

// 用于评标报告专家确认
export function scpDealBidReportExpertConfirmApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/dealBidReportExpertConfirm",
    method: method,
    data
  });
}

// 当前一轮分包商报价信息查询
export function scpQryCurrentRoundSupPriceApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/qryCurrentRoundSupPrice",
    method: method,
    data
  });
}

// 用于投标分包商列表查询
export function scpQryBidPriceSupListApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/qryBidPriceSupList",
    method: method,
    data
  });
}

// 用于查询采购方案详情
export function scpQueryPurchaseSchemeDetailApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/queryPurchaseSchemeDetail",
    method: method,
    data
  });
}

// 用于分包商澄清列表查询
export function scpQrySupClearNoticeListApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/qrySupClearNoticeList",
    method: method,
    data
  });
}

// 用于公告详情查询
export function scpQryNoticeDetailApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/qryNoticeDetail",
    method: method,
    data
  });
}

// 用于公告发布。
export function scpDealClearNoticeSendApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/dealClearNoticeSend",
    method: method,
    data
  });
}

// 用于评分表查询。
export function scpQryScoreListApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/qryScoreList",
    method: method,
    data
  });
}

// 用于查投标评分模板
export function qryScoreBidPriceConfig(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/qryScoreBidPriceConfig",
    method: method,
    data
  });
}

// 用于投标准备详情查询.
export function scpQryBidPricePrepareApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/qryBidPricePrepare",
    method: method,
    data
  });
}

// 用于开始专家评标
export function scpDealBidEvaStartApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/dealBidEvaStart",
    method: method,
    data
  });
}

// 用于开始专家评标 校验
export function checkIsExistExpertProcess(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/checkIsExistExpertProcess",
    method: method,
    data
  });
}

// 用于专家评标菜单列表查询
export function scpListBidEvaMenuApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/listBidEvaMenu",
    method: method,
    data
  });
}

// 用于评分模板列表查询.
export function scpQryScoreTemplateListApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/qryScoreTemplateList",
    method: method,
    data
  });
}

// 用于评分模板新增.
export function scpDealScoreTemplateOperateApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/dealScoreTemplateOperate",
    method: method,
    data
  });
}

// 用于评分评分模板删除
export function scpDealScoreTemplateDeleteApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/dealScoreTemplateDelete",
    method: method,
    data
  });
}

// 用于评分模板详情查询.
export function scpQryScoreTemplateDetailApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/qryScoreTemplateDetail",
    method: method,
    data
  });
}

// 用于专家评标环节状态查询
export function scpQryBidEvaProcessStatusApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/qryBidEvaProcessStatus",
    method: method,
    data
  });
}

export function pullYgyPurchaseRisk(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/pullYgyPurchaseRisk",
    method: method,
    data
  });
}

// 用于已报名分包商下拉列表查询
export function scpQryJoinSupSelectListApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/qryJoinSupSelectList",
    method: method,
    data
  });
}

// 用于分包商报价详情查询。
export function scpQrySupBidPriceDetailApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/qrySupBidPriceDetail",
    method: method,
    data
  });
}

// 用于分包商报价信息查询
export function scpQrySupBidPriceInfoApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/qrySupBidPriceInfo",
    method: method,
    data
  });
}

// 文件压缩批量下载
export function scpBatchDownloadByUploadIdsApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/oss/batchDownloadByUploadIds",
    method: method,
    data
  });
}

// 用于评标报告专家确认详情查询
export function scpQryBidReportExpertConfirmDetailApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/qryBidReportExpertConfirmDetail",
    method: method,
    data
  });
}

// 用于评分环节统一前置校验
export function scpDealBidEvaCheckApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/dealBidEvaCheck",
    method: method,
    data
  });
}

// 用于判断专家是否是首次签到。
export function scpCheckExpertFirstSignApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/checkExpertFirstSign",
    method: method,
    data
  });
}

// 查询机构用户详情
export function scpGetEmpInfoApi(data, method = "POST") {
  return request({
    url: "apis/bid-scp/org/getEmpInfo",
    method: method,
    data
  });
}

// 开标情况记录表
export function scpQryBidOpenRecord(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/qryBidOpenRecord",
    method: method,
    data
  });
}

// 关联关系查询
export function getUrl(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/users/signup/getUrl",
    method: method,
    data
  });
}

// 重复人员信息
export function querySupQuotePersonDetail(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/querySupQuotePersonDetail",
    method: method,
    data
  });
}

// 查询报价清单
export function scpQrySupBidOpenDetail(data, method = "POST") {
  return request({
    url: "apis/bid-scp/bidc/qrySupBidOpenDetail",
    method: method,
    data
  });
}

// 查询报价清单
export function scpQrySupQuoteDetail(data, method = "POST") {
  return request({
    url: "/apis/bid-scp/bidc/qrySupQuoteDetail",
    method: method,
    data
  });
}

// 导出专家评分模板
export function scpExportSupQuoteScoreFile(data, method = "POST") {
  return request({
    url: "/apis/bid-scp/bidc/exportSupQuoteScoreFile",
    method: method,
    data
  });
}

// 报价系数抽取列表
export function qryEvaExtractPackList(data, method = "POST") {
  return request({
    url: "/apis/bid-scp/bidc/qryEvaExtractPackList",
    method: method,
    data
  });
}
// 抽取
export function dealEvaExtractPack(data, method = "POST") {
  return request({
    url: "/apis/bid-scp/bidc/dealEvaExtractPack",
    method: method,
    data
  });
}
